import { render, staticRenderFns } from "./RequerimientoEdit.vue?vue&type=template&id=28fdf1d4&scoped=true&"
import script from "./RequerimientoEdit.vue?vue&type=script&lang=js&"
export * from "./RequerimientoEdit.vue?vue&type=script&lang=js&"
import style0 from "./RequerimientoEdit.vue?vue&type=style&index=0&id=28fdf1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fdf1d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VIcon,
  VSpacer,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
})
